/* eslint-disable react/jsx-key */
import React from 'react';

import PropTypes from 'prop-types';
import { useTable, useSortBy } from 'react-table';
import { StatsTable } from '../../../statspro/js/components/common/stats-table/StatsTable';
import { StatsTableHead } from '../../../statspro/js/components/common/stats-table/StatsTableHead';
import { StatsTableBody } from '../../../statspro/js/components/common/stats-table/StatsTableBody';

import { HeaderCellPosition } from './custom-cells/HeaderCellPosition';
import { HeaderCellForm } from './custom-cells/HeaderCellForm';
import { HeaderCellPoints } from './custom-cells/HeaderCellPoints';
import { HeaderCellPercentage } from './custom-cells/HeaderCellPercentage';
import { HeaderCellNextOpponent } from './custom-cells/HeaderCellNextOpponent';
import { HeaderCellBettingOdds } from './custom-cells/HeaderCellBettingOdds';

import { BodyCellPoints } from './custom-cells/BodyCellPoints';
import { BodyCellPercentage } from './custom-cells/BodyCellPercentage';

import { BodyCellNextOpponent } from './custom-cells/BodyCellNextOpponent';
import { BodyCellForm } from './custom-cells/BodyCellForm';
import { BodyCellPosition } from './custom-cells/BodyCellPosition';
import { BodyCellBettingOdds } from './custom-cells/BodyCellBettingOdds';

export const Table = ({
    columns,
    data,
    modifier,
    cssClass,
    conferenceLabel,
    conferenceModifier
}) => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
        useTable(
            {
                columns,
                data,
                disableSortRemove: true,
                disableSortBy: true
            },
            useSortBy
        );

    // ===== Render ===== //

    return (
        <>
            {conferenceLabel && (
                <h1
                    className={`stats-table__conference-title ${conferenceModifier}`}
                >
                    {conferenceLabel}
                </h1>
            )}

            <StatsTable
                modifier={modifier}
                getTableProps={getTableProps}
                cssClass={cssClass}
            >
                <StatsTableHead
                    headerGroup={headerGroups[0]}
                    skipColumns={['positionChange', 'club', 'isPlaying']}
                    customCells={{
                        position: (column, key) => (
                            <HeaderCellPosition
                                column={column}
                                key={`header-position--${key}`}
                            />
                        ),
                        points: (column, key) => (
                            <HeaderCellPoints
                                column={column}
                                key={`header-points--${key}`}
                            />
                        ),
                        percentage: (column, key) => (
                            <HeaderCellPercentage
                                column={column}
                                key={`header-percentage--${key}`}
                            />
                        ),
                        form: (column, key) => (
                            <HeaderCellForm
                                column={column}
                                key={`header-form--${key}`}
                            />
                        ),
                        nextOpponent: (column, key) => (
                            <HeaderCellNextOpponent
                                column={column}
                                key={`header-nextopponent--${key}`}
                            />
                        ),
                        bettingOdds: (column, key) => (
                            <HeaderCellBettingOdds
                                column={column}
                                key={`header-betting-odds--${key}`}
                            />
                        )
                    }}
                />

                <StatsTableBody
                    rows={rows}
                    prepareRow={prepareRow}
                    getTableBodyProps={getTableBodyProps}
                    skipCells={['positionChange', 'club', 'isPlaying']}
                    customCells={{
                        position: (row, cell, cellProps, key) => (
                            <BodyCellPosition
                                cell={cell}
                                cellProps={cellProps}
                                key={`body-position--${key}`}
                            />
                        ),
                        points: (row, cell, cellProps, key) => (
                            <BodyCellPoints
                                cell={cell}
                                cellProps={cellProps}
                                key={`body-points--${key}`}
                            />
                        ),
                        percentage: (row, cell, cellProps, key) => (
                            <BodyCellPercentage
                                cell={cell}
                                cellProps={cellProps}
                                key={`body-percentage--${key}`}
                            />
                        ),
                        form: (row, cell, cellProps, key) => (
                            <BodyCellForm
                                cell={cell}
                                cellProps={cellProps}
                                key={`body-form--${key}`}
                            />
                        ),
                        nextOpponent: (row, cell, cellProps, key) => (
                            <BodyCellNextOpponent
                                cell={cell}
                                cellProps={cellProps}
                                key={`body-nextopponent--${key}`}
                            />
                        ),
                        bettingOdds: (row, cell, cellProps, key) => (
                            <BodyCellBettingOdds
                                cell={cell}
                                cellProps={cellProps}
                                key={`body-betting-odds--${key}`}
                            />
                        )
                    }}
                />
            </StatsTable>
        </>
    );
};

Table.propTypes = {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    modifier: PropTypes.string,
    cssClass: PropTypes.string,
    conferenceLabel: PropTypes.any,
    conferenceModifier: PropTypes.any
};
